import React from 'react';
import styled from 'styled-components';

import { useDictionary } from 'bdvp-common/src/hooks/config';
import StatusTemplate from 'bdvp-common/src/components/StatusTemplate';

import BrandingComponent from '../Branding';

const Branding = styled(BrandingComponent)`
    margin-top: 16px;
`;

const MaintenancePage = () => {

    const {
        maintenance_page_text = 'Sorry, we’ll be back soon!',
    } = useDictionary();

    return (
        <StatusTemplate
            title={maintenance_page_text}
            message={<Branding />}
        />
    );

};

export default MaintenancePage;
